import { render, staticRenderFns } from "./DisplayProtocolService.vue?vue&type=template&id=f94a18d4&scoped=true"
import script from "./DisplayProtocolService.vue?vue&type=script&lang=js"
export * from "./DisplayProtocolService.vue?vue&type=script&lang=js"
import style0 from "./DisplayProtocolService.vue?vue&type=style&index=0&id=f94a18d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94a18d4",
  null
  
)

export default component.exports